// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";

export default class SubpageCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    withSlug(slug) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.slug == slug );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    withSubpageCode(code) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.code == code );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

}